import { Component, OnInit } from '@angular/core';
import { GoogleEventsKeys } from 'src/app/shared/constants/google-events-keys';


@Component({
  selector: 'ben-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit{
  constructor() { }
  ngOnInit() {
    gtag('event', GoogleEventsKeys.LinkNotFoundPageLoad);
  }
}
